import styles from './Tooltip.module.scss'
import { Typography } from '../Typography/Typography'

interface TooltipProps {
  text: string
  x: number
  y: number
}

function capitalizeText(text: string) {
  return text
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const Tooltip = ({ text, x, y }: TooltipProps) => {
  const tooltipContent = 'Discover More about ' + capitalizeText(text)

  return (
    <div className={styles.wrapper} style={{ top: y + 'px', left: x + '%' }}>
      <div className={styles.content}>
        <Typography type="s-body" tag="p" className={styles.text} color="#fff">
          {tooltipContent}
        </Typography>
      </div>
      <div className={styles.arrow}>
        <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.29289 3.29289C3.68342 3.68342 4.31658 3.68342 4.70711 3.29289L8 0L0 0L3.29289 3.29289Z"
            fill="#4C4C4C"
          />
        </svg>
      </div>
    </div>
  )
}

export default Tooltip
